import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface BookingSectionProps {
  status: 'ongoing' | 'upcoming' | 'past'
  price: string
  departureDate: string
}

export function BookingSection({ 
  status, 
  price, 
  departureDate 
}: BookingSectionProps) {
  const { t } = useTranslation()
  if (status === 'past') {
    return null
  }

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      {status === 'ongoing' ? (
        <>
          <h3 className="text-xl font-bold text-card-foreground mb-4">Tour Status</h3>
          
          <div className="space-y-4 mb-6">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Price per person:</span>
              <span className="font-bold text-primary">{price}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Departure:</span>
              <span className="font-medium">{new Date(departureDate).toLocaleDateString()}</span>
            </div>
          </div>

          <motion.div
            className="w-full bg-secondary text-secondary-foreground py-3 px-6 rounded-lg font-semibold text-center"
          >
            Tour in Progress
          </motion.div>
        </>
      ) : (
        <>
          <h3 className="text-xl font-bold text-card-foreground mb-4">Interested in This Tour?</h3>
          
          <div className="space-y-4 mb-6">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Price per person:</span>
              <span className="font-bold text-primary">{price}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Departure:</span>
              <span className="font-medium">{new Date(departureDate).toLocaleDateString()}</span>
            </div>
          </div>

          <Link to="/contact">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="w-full bg-primary text-primary-foreground py-3 px-6 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
            >
              Book Now
            </motion.button>
          </Link>
        </>
      )}
    </div>
  )
}
